import {createStyles, makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            borderRadius: theme.shape.borderRadius,
            overflow: 'hidden',
            '&:has(input:-webkit-autofill), &:has(input:-webkit-autofill:hover), &:has(input:-webkit-autofill:focus)': {
                backgroundColor: 'rgb(232, 240, 254)',
            },
        },
        label: {
            marginBottom: theme.spacing(0.5),
            color: theme.palette.primary.main,
        },
    }),
);

export default useStyles;
